import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsVintage({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" id="Path" fillRule="evenodd" clipRule="evenodd" d="M8 15H2C1.44772 15 1 14.3732 1 13.6V11.9913C1 11.6734 1.07727 11.365 1.21911 11.1167L3 8L1.219 4.88175C1.07723 4.63355 1 4.32522 1 4.00742V2.4C1 1.6268 1.44772 1 2 1H8C8.55229 1 9 1.6268 9 2.4V4.00891C9 4.32681 8.92272 4.63524 8.78087 4.88347L7 8L8.78087 11.1165C8.92272 11.3648 9 11.6732 9 11.9911V13.6C9 14.3732 8.55229 15 8 15Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default OrdinalsVintage;